import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {taskRequest} from "../store/actions/task.js";
import Cookies from 'js-cookie'

const Timer = () => {
    const dispatch = useDispatch();
    const dayReports = useSelector((state) => state.task.duration);
    const employee = useSelector((state) => state.manager.employee);
    const [allDuration, setAllDuration] = useState('');
    const [newDuration, setNewDuration] = useState({});

    useEffect(() => {
        (async () => {
            if(employee.id){
                await dispatch(taskRequest({prof:Cookies.get('profession'),id:employee.id}))
            }
        })()
    }, [employee]);

    useEffect(() => {
        setNewDuration({...dayReports,get_date: new Date()})
    },[dayReports])

    useEffect(() => {
        const timer = setInterval(() => {
            updateTimer();
        }, 1000);

        return () => clearInterval(timer);
    }, [newDuration]);


    const convertHToS = (timeInHour) => {
        const [h, m, s] = timeInHour.split(":").map(Number);
        return h * 3600 + m * 60 + s;
    };
    const secondsToHms = (d) => {
        const h = Math.floor(d / 3600).toString().padStart(2, "0");
        const m = Math.floor((d % 3600) / 60).toString().padStart(2, "0");
        const s = Math.floor(d % 60).toString().padStart(2, "0");
        return `${h}:${m}:${s}`;
    };

    const updateTimer = () => {
        if (!newDuration?.all_duration) return;
        const { all_duration, ongoing_task_count, get_date } = newDuration;
        const date = new Date();
        const ms = moment(date).diff(moment(get_date));
        const duration = moment.duration(ms);
        const elapsedTime = `${Math.floor(duration.asHours())}${moment.utc(ms).format(":mm:ss")}`;

        const sumSeconds = convertHToS(elapsedTime) * ongoing_task_count + convertHToS(all_duration);
        setAllDuration(secondsToHms(sumSeconds));
    };

    return <div>{allDuration || `${dayReports.all_duration?.split(':')[0].length === 2?'':'0'}${dayReports.all_duration || '0:00:00'}`}</div>;
};

export default Timer;
